import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HamperActions from '../../../redux/HampersOrder/actions';
import helpdeskActions from '../../../redux/Helpdesk/actions';
import commonActions from '../../../redux/Common/actions';
import Breadcrumb from "./Breadcrumb";
import { useHistory } from "react-router-dom";
import Preloader from '../../layouts/Preloader';
import ReactPagination from '../../common/React-Pagination';
import { BsArrowUp, BsArrowDown } from 'react-icons/bs';
import SortingOrders from '../../common/SortingOrders';
import moment from 'moment';

export default function Ordertable() {

    const dispatch = useDispatch();
    const history = useHistory();

    const { AllHamperOrders } = useSelector(state => state.HamperOrderReducer);

    const { NotRespondHamperOrders } = useSelector(state => state.HelpdeskReducer);

    const { Filtered_Dates } = useSelector(state => state.commonReducer);

    const [fetchSuccess, setFetchSuccess] = useState(false);
    const [search, setsearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [filteredData2, setFilteredData2] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [postsPerPage, setPostPerPage] = useState(10);
    const [startDate, setStartDate] = useState((Filtered_Dates?.Page === 'AHO' && moment(Filtered_Dates?.StartDate, 'DD-MM-YYYY').format('YYYY-MM-DD')) ? moment(Filtered_Dates?.StartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '');

    //field: OD or DD / type: A or D
    let [sorting, setSorting] = useState([
        { table: 0, field: "OD", type: "D" },
        { table: 1, field: "OD", type: "D" },
    ]);

    //dispatch apis
    useEffect(() => {
        dispatch({ type: HamperActions.GET_ADMIN_HAMPER_ORDERS_LIST });
        dispatch({ type: helpdeskActions.GET_NOT_RESPOND_HAMPER_ORDERS });
        // eslint-disable-next-line 
    }, []);

    //get search input value - above 5kg
    const handleSearchbar = (e) => {
        setsearch(e.target.value.toLowerCase());
        setCurrentPage(0);
    };

    //validate the list is empty or not - above 5kg
    useEffect(() => {
        if (AllHamperOrders?.message === 'No Records Found') {
            setFilteredData([]);
        } else {
            let FilteredDataWithDate = [];
            if (Filtered_Dates?.Page === 'AHO' && Filtered_Dates?.StartDate) {
                AllHamperOrders.filter(val => {
                    if (moment(val.Created_On, 'DD-MM-YYYY hh:mm A').format('DD-MM-YYYY') === Filtered_Dates?.StartDate) {
                        return FilteredDataWithDate.push(val);
                    } else {
                        return null;
                    }
                });
            } else {
                FilteredDataWithDate = AllHamperOrders;
            };
            setFilteredData(FilteredDataWithDate.filter(val => {
                if (search === '') {
                    return val;
                } else if ((val.Id && val.Id.toLowerCase().includes(search)) ||
                    (val.HampersName && val.HampersName.toLowerCase().includes(search)) ||
                    (val.UserName && val.UserName.toLowerCase().includes(search)) ||
                    (val.VendorName && val.VendorName.toLowerCase().includes(search)) ||
                    (val.Status && val.Status.toLowerCase().includes(search)) ||
                    (val.DeliveryDate && val.DeliveryDate.toLowerCase().includes(search))
                ) {
                    return val;
                } else {
                    return null;
                }
            }))
        };
    }, [AllHamperOrders, search, Filtered_Dates]);

    const indexOfFirstPost = (currentPage * postsPerPage) % filteredData?.length;
    const indexOfLastPost = indexOfFirstPost + postsPerPage;
    const currentdata = filteredData.slice(indexOfFirstPost, indexOfLastPost);

    // Change page
    const paginate = (event) => {
        setCurrentPage(event.selected);
    };

    const handleShowPerPage = (e) => {
        setPostPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    //view details page
    function ViewOrderDetails(order) {
        history.push('/Admin-hamper-order-details', { OrderId: order._id });
    };

    const handleSelectedDate = (e) => {
        setStartDate(e.target.value);
        setCurrentPage(0);
        if (e.target.value) {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: moment(e.target.value, 'YYYY-MM-DD').format('DD-MM-YYYY'), Page: 'AHO' } });
        } else {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: null, Page: null } });
        };
        let newArray = sorting;
        newArray[0].field = 'OD';
        newArray[0].type = 'D';
        setSorting(newArray);
    };

    const handlePageRefresh = (e) => {
        e.preventDefault();
        dispatch({ type: HamperActions.GET_ADMIN_HAMPER_ORDERS_LIST });
        dispatch({ type: helpdeskActions.GET_NOT_RESPOND_HAMPER_ORDERS });
        setSorting([
            { table: 0, field: "OD", type: "D" },
            { table: 1, field: "OD", type: "D" }
        ]);
        setStartDate();
        setsearch('');
    };

    useEffect(() => {
        if (NotRespondHamperOrders?.message === 'No Orders') {
            setFilteredData2([]);
        } else {
            // eslint-disable-next-line
            setFilteredData2(NotRespondHamperOrders.filter(val => {
                if (val.VendorID) { return val }
            }));
        };
    }, [NotRespondHamperOrders]);

    const handleSorting = (e, field, table) => {
        e.preventDefault();
        let type, filterData;
        (sorting[table]?.type === 'A') ? type = 'D' : type = 'A';
        let newArray = [...sorting];
        newArray[table].type = type;
        newArray[table].field = field;
        setSorting(newArray);
        (table === 0) ? filterData = filteredData : filterData = filteredData2;
        let result = SortingOrders({ type, field, filterData });
        (table === 0) ? setFilteredData(result) : setFilteredData2(result);
    };

    //loading
    useEffect(() => {
        if (AllHamperOrders.length === 0 || NotRespondHamperOrders.length === 0) {
            setFetchSuccess(false);
        } else {
            setFetchSuccess(true);
        }
        // eslint-disable-next-line
    }, [AllHamperOrders, NotRespondHamperOrders]);

    return (
        <>
            {!fetchSuccess ?
                <Preloader fetchSuccess={fetchSuccess} /> :
                <div className="ms-content-wrapper">
                    <div className="row">
                        <div className="col-md-12">
                            <Breadcrumb handlePageRefresh={handlePageRefresh} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ms-panel">
                                <div className="ms-panel-body tabledata-background">
                                    <h6 className='text-uppercase font-weight-bold'>Hamper Orders List</h6>
                                    <span className="float-right add-banner-button col-sm-3 col-md-3 mb-2">
                                        <div id="data-table-4_filter" className="dataTables_filter">
                                            <input
                                                type='date'
                                                maxLength={4}
                                                max={"9999-12-31"}
                                                className="form-control mt-4"
                                                disabled={AllHamperOrders.message === 'No Records Found' ? true : false}
                                                aria-controls="data-table-4"
                                                onChange={handleSelectedDate}
                                                value={startDate || ''}
                                            />
                                        </div>
                                    </span>
                                </div>
                                <div className='header-break-line'> <hr /> </div>
                                <div className="ms-panel-body tabledata-background">
                                    <div className="table-responsive Scrollbar-Style">
                                        <div id="data-table-5_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" id="data-table-5_length">
                                                        <label>
                                                            Show
                                                            <select name="data-table-5_length" aria-controls="data-table-5" className="custom-select custom-select-sm form-control form-control-sm" onChange={handleShowPerPage}>
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                            </select> entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 mb-2">
                                                    <div id="data-table-4_filter" className="dataTables_filter">
                                                        <label className="font-weight-bold">Search :
                                                            <input
                                                                type='Search'
                                                                className="form-control form-control-sm"
                                                                placeholder="type here to search..."
                                                                onChange={handleSearchbar}
                                                                value={search || ''}
                                                                aria-controls="data-table-4"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table className="table table-hover thead-primary">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Order ID</th>
                                                                <th scope="col">Hamper Name</th>
                                                                <th scope="col">Customer Name</th>
                                                                <th scope="col">Vendor Name</th>
                                                                <th scope="col">Ordered Date <span className='cursor' onClick={(e) => handleSorting(e, 'OD', 0)}><BsArrowUp className={`sort-up-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'OD' && sorting[0]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'OD' && sorting[0]?.type === 'D' ? 'sort-descending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Delivery Date <span className='cursor' onClick={(e) => handleSorting(e, 'DD', 0)}><BsArrowUp className={`sort-up-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'DD' && sorting[0]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'DD' && sorting[0]?.type === 'D' ? 'sort-ascending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Status</th>
                                                            </tr>
                                                        </thead>
                                                        {filteredData.length > 0 ?
                                                            <tbody>
                                                                {currentdata.map((order, i) =>
                                                                    <tr className='cursor' onClick={() => ViewOrderDetails(order)} key={i}>
                                                                        <th className='id-column' scope="row">{order.Id}</th>
                                                                        <td>{order.HampersName}</td>
                                                                        <td> {order.UserName}</td>
                                                                        <td> {order.VendorName}</td>
                                                                        <td> {order.Created_On}</td>
                                                                        <td>{order.DeliveryDate}</td>
                                                                        <td className='price-align3-row'><span className={(order.Status?.toUpperCase())?.replace(/ /g, '')}>{order.Status}</span></td>
                                                                    </tr>
                                                                )}
                                                            </tbody> :
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={7} className='font-weight-bold'>No Records Found</td>
                                                                </tr>
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {filteredData.length > postsPerPage &&
                                        <ReactPagination
                                            paginate={paginate}
                                            pageCount={Math.ceil(filteredData?.length / postsPerPage)}
                                            currentPage={currentPage}
                                            currentdata={currentdata}
                                            totalPosts={filteredData.length}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ms-panel">
                                <div className="ms-panel-header">
                                    <h6> Hamper Orders List - No Response from Vendors</h6>
                                </div>
                                <div className="ms-panel-body tabledata-background">
                                    <div className="table-responsive Scrollbar-Style">
                                        <div id="data-table-5_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table className="table table-hover thead-primary">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Order ID</th>
                                                                <th scope="col">Hamper Name</th>
                                                                <th scope="col">Customer Name</th>
                                                                <th scope="col">Vendor Name</th>
                                                                <th scope="col">Ordered Date <span className='cursor' onClick={(e) => handleSorting(e, 'OD', 1)}><BsArrowUp className={`sort-up-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'OD' && sorting[1]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'OD' && sorting[1]?.type === 'D' ? 'sort-descending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Delivery Date <span className='cursor' onClick={(e) => handleSorting(e, 'DD', 1)}><BsArrowUp className={`sort-up-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'DD' && sorting[1]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'DD' && sorting[1]?.type === 'D' ? 'sort-ascending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Status</th>
                                                            </tr>
                                                        </thead>
                                                        {filteredData2.length !== 0 ?
                                                            <tbody>
                                                                {filteredData2.map((order, i) =>
                                                                    <tr className='cursor' onClick={() => ViewOrderDetails(order)} key={i}>
                                                                        <th className='id-column' scope="row">{order.Id}</th>
                                                                        <td>{order.HampersName}</td>
                                                                        <td> {order.UserName}</td>
                                                                        <td> {order.VendorName}</td>
                                                                        <td> {order.Created_On}</td>
                                                                        <td>{order.DeliveryDate}</td>
                                                                        <td className='price-align3-row'><span className={(order.Status?.toUpperCase())?.replace(/ /g, '')}>{order.Status}</span></td>
                                                                    </tr>
                                                                )}
                                                            </tbody> :
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={7} className='font-weight-bold'>No Records Found</td>
                                                                </tr>
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};